export default "__VITE_ASSET__DMUbfeEv__"